<template>
  <div>
    <div class="classBnaer">
      <div class="jifenTitle">
        <span>我的积分：</span><span class="jiFentext_1">{{ surplusIntegral }}</span>
        <!-- <span class="jiFentext_2">积分可在平台商城里面兑换商品积分有效期三年过期将自动清零</span> -->
      </div>
      <div class="jifenBtn">
        <div class="obtained" @click="getInfo(1)" :class="showObtained == true ? 'active' : ''">积分获得记录</div>
        <div class="use" @click="getInfo(2)" :class="showUse == true ? 'active' : ''">积分使用记录</div>
      </div>
      <!-- 获取表格 -->
      <div class="obtainedTable" v-if="showObtained">
        <el-table :data="tableInfo" style="width: 100%">
          <el-table-column prop="INTEGRAL_ITEM" align="center" label="获得类型"> </el-table-column>
          <el-table-column prop="CREATETIME" align="center" label="获得时间"> </el-table-column>
          <el-table-column prop="INTEGRAL" align="center" label="获得积分" class="text_5"> </el-table-column>
        </el-table>
      </div>
      <!-- 使用表格 -->
      <div class="useTable" v-if="showUse">
        <el-table :data="tableInfo" style="width: 100%">
          <el-table-column prop="INTEGRAL_ITEM" align="center" label="使用类型"> </el-table-column>
          <el-table-column prop="CREATETIME" align="center" label="使用时间"> </el-table-column>
          <el-table-column prop="INTEGRAL" align="center" label="使用积分"> </el-table-column>
        </el-table>
      </div>
      <div style="display: flex; justify-content: center; margin-top: 50px">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[10, 20, 30, 40]"
          :page-size.sync="pageSize"
          layout="total, sizes, prev, pager, next"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import { findIntIntegralList } from '@/api/study';
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    // 这里存放数据
    return {
      total: 0,
      tableInfo: [],
      pageNum: 1,
      pageSize: 10,
      showObtained: true,
      showUse: false,
      surplusIntegral: 0 //总积分
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},

  // 方法集合
  methods: {
    getInfo(index) {
      if (index == 1) {
        this.pageNum=1
        this.getJifen('01');
        this.showObtained = true;
        this.showUse = false;
        
      } else {
        this.pageNum=1

        this.getJifen('02');
        this.showObtained = false;
        this.showUse = true;
      }
    },
    handleSizeChange(val) {
      this.pageSize = val;
      if (this.showObtained == true) {
        this.getJifen('01');
      } else {
        this.getJifen('02');
      }
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      if (this.showObtained == true) {
        this.getJifen('01');
      } else {
        this.getJifen('02');
      }
    },
    //获取表格信息type01获得
    getJifen(type) {
    

      findIntIntegralList({ type: type, pageNum: this.pageNum, pageSize: this.pageSize }).then(res => {
        this.total = res.data.total;
        this.tableInfo = res.data.rows;
        this.surplusIntegral = res.data.data.surplusIntegral;
      });
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getJifen('01');
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）

  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {} // 生命周期 - 挂载之前
};
</script>
<style lang="less" scoped>
/* //@import url(); 引入公共css类 */
.classBnaer {
  width: 1170px;
  background: #fff;
  padding: 30px 20px;
  min-height: 745px;
  border-radius: 6px;
  .jifenTitle {
    height: 45px;
    width: 100%;
    border-bottom: 1px solid #eeeeee;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 18px;
    color: #333333;
    .jiFentext_1 {
      color: rgba(255, 136, 51, 1);
    }
    .jiFentext_2 {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #999999;
      margin-left: 20px;
    }
  }
  .jifenBtn {
    display: flex;
    margin-top: 20px;
    .obtained {
      width: 120px;
      height: 30px;
      border-radius: 16px 16px 16px 16px;
      border: 1px solid #d7d7d7;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #666666;
      text-align: center;
      line-height: 30px;
    }
    .use {
      width: 120px;
      height: 30px;
      border: 1px solid #d7d7d7;
      border-radius: 16px 16px 16px 16px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #666666;
      text-align: center;
      line-height: 30px;
      margin-left: 20px;
    }
  }
}
.active {
  background: #ff8833;
  border: 0 !important;
  color: #fff !important;
}
.obtainedTable {
  margin-top: 20px;
  ::v-deep {
    .has-gutter {
      tr {
        th {
          background: #f4f3f4 !important;
        }
      }
    }
    .el-table__row {
      .el-table__cell:nth-child(3) {
        color: rgba(255, 15, 15, 1);
      }
    }
  }
}
.useTable {
  margin-top: 20px;
  ::v-deep {
    .has-gutter {
      tr {
        th {
          background: #f4f3f4 !important;
        }
      }
    }
    .el-table__row{
    .el-table__cell:nth-child(3) {
      color: rgba(255, 15, 15, 1) !important;
    }
  }
  }
  
}
</style>
